import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import createHistory from 'history/createBrowserHistory';
import registerServiceWorker from './registerServiceWorker';
import createStore from './redux/store';

import { BrowserRouter as Router } from 'react-router-dom';

import history from "./history";

import App from './Screens/App';

import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import './assets/mdb/mdb.css';



ReactDOM.render(
  <Provider store={createStore(window.__INITIAL_STATE__)}>
    <Router history={history} basename='/coach'>
      <App />
    </Router>
  </Provider>,
  document.querySelector('#root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.jsx